<template>
  <table class="table">
    <tbody>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.header') }}:</strong>
          </h6>
          {{ data.date_save }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.module') }}:</strong>
          </h6>
          <el-tag type="info">
            {{ data.module }}
          </el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.farm') }}:</strong>
          </h6>
          <el-tag type="info">
            {{ data.farm_name }}
          </el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.creatorUser') }}:</strong>
          </h6>
          {{ data.store_user_name }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.creationDate') }}:</strong>
          </h6>
          {{ data.createdAt }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.updaterUser') }}:</strong>
          </h6>
          {{ data.updated_user_name }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.updateDate') }}:</strong>
          </h6>
          {{ data.updated_date }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'table-details',
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
};
</script>
